import {
  Directive,
  effect,
  inject,
  input,
  inputBinding,
  TemplateRef,
  untracked,
  ViewContainerRef
} from '@angular/core';
import { SkeletonComponent } from './skeleton.component';

@Directive({
  selector: '[appSkeleton]'
})
export class SkeletonDirective {
  #tpl = inject(TemplateRef<HTMLElement>);
  #vcr = inject(ViewContainerRef);
  readonly isLoading = input(false, { alias: 'appSkeleton' });
  readonly repeat = input(1, { alias: 'appSkeletonRepeat' });
  readonly width = input('100%', { alias: 'appSkeletonWidth' });
  readonly height = input('1.25rem', { alias: 'appSkeletonHeight' });
  readonly className = input('', { alias: 'appSkeletonClassName' });
  readonly itemClassName = input('', { alias: 'appSkeletonItemClassName' });

  constructor() {
    effect(() => {
      const isLoading = this.isLoading();
      untracked(() => this.updateView(isLoading));
    });
  }

  private updateView(isLoading: boolean) {
    this.#vcr.clear();

    if (isLoading) {
      this.#vcr.createComponent(SkeletonComponent, {
        bindings: [
          inputBinding('isLoading', this.isLoading),
          inputBinding('repeat', this.repeat),
          inputBinding('width', this.width),
          inputBinding('height', this.height),
          inputBinding('className', this.className),
          inputBinding('itemClassName', this.itemClassName)
        ]
      });
    } else {
      this.#vcr.createEmbeddedView(this.#tpl);
    }
  }
}
